import Checkbox from './Checkbox'
import CheckboxGroup from './Group'

Checkbox.Group = CheckboxGroup
export default Checkbox




// WEBPACK FOOTER //
// ./components/checkbox/index.js